module.exports = __webpack_public_path__ + "fonts/fa-solid-900.3348406.woff";